/** Hash link for in-page sections; off home, prefix with `/` so navigation lands on home first. */
export function hashHref(pathname: string, segment: string) {
  if (segment.startsWith("/")) return segment;
  return pathname === "/" ? `#${segment}` : `/#${segment}`;
}
